import { all, call, put, takeLatest } from 'redux-saga/effects';
import { request } from '../modules/client';
import { ActionTypes } from '../constants/index';

// // TODO: 

export function* ping() {
  try {
    yield call(request,
      'api/ping', {
        payload: {},
      }
    );
    yield put({
      type: ActionTypes.NETWORK_SUCCESS,
      payload: {},
    });
  }
  catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.NETWORK_ERROR,
      payload: err,
    });
  }
}


export default function* root() {
  yield all([
    takeLatest(ActionTypes.NETWORK_REQUEST, ping),
  ]);
}



// WEBPACK FOOTER //
// ./scripts/sagas/app.js